import { useCallback, useState } from 'react';
import { useStoreInfo, useToast } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';
import chargebackServiceBR from '../services/chargebackServiceBR';

export interface UseDefenseModelUrlReturn {
  loading: boolean;
  error: string | null;
  fetchUrl: () => Promise<void>;
}

export function useDefenseModelUrl(orderId: string): UseDefenseModelUrlReturn {
  const { t } = useTranslationWithPrefix('chargebackUpload');
  const { storeInfo } = useStoreInfo();
  const { showToastError } = useToast();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUrl = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const url = await chargebackServiceBR.getDefenseModelUrl(
        orderId,
        storeInfo.id,
      );
      // Open tab after URL resolves. Using noopener to prevent tabnabbing.
      window.open(url, '_blank', 'noopener');
    } catch (err) {
      const errorMessage = t('defenseInfo.defenseModelError');
      setError(errorMessage);
      showToastError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [orderId, storeInfo.id, showToastError, t]);

  return {
    loading,
    error,
    fetchUrl,
  };
}
